import { render, staticRenderFns } from "./AppSelector.html?vue&type=template&id=15d9a744&external"
import script from "./AppSelector.js?vue&type=script&lang=js&external"
export * from "./AppSelector.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import VBtn from '@/agilis/wrappers/VBtn/VBtn.vue'
import VCard from '@/agilis/wrappers/VCard/VCard.vue'
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VIcon,VRow,VSpacer})
